// Quotes user input as one APL string literal: JSON escaping covers the
// quotes and backslashes that could otherwise end the literal.
export const toAplString = (value: string) => JSON.stringify(value)
